import { Alert, AlertDescription, AlertTitle } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { InfoIcon } from 'components/icons';
import React from 'react';

export const EmptyResponsesAlert = ({ isClosed }: { isClosed: boolean }) => {
  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={6}
      borderRadius="lg"
    >
      <InfoIcon size="4x" />

      <AlertTitle mt={6} mb={1} fontSize="lg">
        {isClosed ? t`No responses` : t`No responses yet`}
      </AlertTitle>

      <AlertDescription maxWidth="sm">
        {isClosed
          ? t`Nobody responded to your form before it was closed.`
          : t`Responses will appear here when users fill out your form.`}
      </AlertDescription>
    </Alert>
  );
};
